import Date_ from './Date_'

export default class Before extends Date_ {
  get ruleName () {
    return 'before'
  }

  passes () {
    return this.momentFormat(this.value).isBefore(this.momentFormat(this.date), 'd')
  }
}
